import React, { useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.33, 1, 0.68, 1];

// Line-by-line masked reveal for headings. Pass array of lines.
export function MaskLines({ lines, className = "", delay = 0, tag = "span" }) {
  const Tag = motion[tag] || motion.span;
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span className="line-mask" key={i}>
          <Tag
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, ease: EASE, delay: delay + i * 0.12 }}
            style={{ display: "block" }}
          >
            {line}
          </Tag>
        </span>
      ))}
    </span>
  );
}

// Scroll-triggered fade + rise
export function Reveal({ children, className = "", delay = 0, y = 40, once = true }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once, margin: "-10% 0px -10% 0px" });
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

// Reveal words of a heading in sequence on scroll
export function RevealLines({ lines, className = "", childClassName = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-12% 0px" });
  return (
    <span ref={ref} className={className}>
      {lines.map((line, i) => (
        <span className="line-mask" key={i}>
          <motion.span
            initial={{ y: "110%" }}
            animate={inView ? { y: 0 } : {}}
            transition={{ duration: 1, ease: EASE, delay: i * 0.1 }}
            style={{ display: "block" }}
            className={childClassName}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
